<script>
import { mapGetters } from 'vuex'
import ChargeResource from '@/resources/charge'
import TermsOfServiceLink from '@/components/TermsOfServiceLink.vue'

export default {
    name: 'AccountSubscription',
    components: { TermsOfServiceLink },
    computed: {
        ...mapGetters(['userResource', 'isApexClub', 'creditsBalance'])
    },
    methods: {
        async onUnenrollSubscription() {
            this.$refs.cancelSubscription.hide()
            await ChargeResource.creditUnenrollUser()
            this.userResource.set('credits_subscription_in_good_standing', false)
        },
        nthDayOfMonth(day) {
            const moment = require('moment')
            return moment(day, 'D').format('Do')
        }
    }
}
</script>

<template>
    <div>
        <div class="mb-4">
            <h4 class="mb-1">Subscription</h4>
            <p class="text-muted mb-0">Manage your {{ $appConfig('APEX_CLUB_NAME', 'Apex Club') }} membership.</p>
        </div>

        <b-card v-if="userResource.attributes.credits_subscription_in_good_standing">
            <dl class="row mb-0">
                <dt class="col-sm-4">Apex Club</dt>
                <dd class="col-sm-8"><strong class="text-success"><b-icon icon="patch-check-fill" /> Member</strong></dd>
                <dt class="col-sm-4">Credits Balance</dt>
                <dd class="col-sm-8"><strong><b-icon icon="currency-exchange" /> {{ creditsBalance }} Credits</strong></dd>
                <dt class="col-sm-4">Subscription</dt>
                <dd class="col-sm-8">
                    <strong><b-icon icon="arrow-repeat" /> {{ userResource.attributes.credits_recurring }} credits monthly on the {{ nthDayOfMonth(userResource.attributes.credits_cycle_day_of_month) }} — {{ currencySymbol() }}{{ moneyFormat(userResource.attributes.credits_recurring_cents) }}</strong>
                </dd>
            </dl>
            <template #footer>
                <small><a href="javascript:{};" class="text-muted" @click="$refs.cancelSubscription.show()">Cancel Subscription</a></small>
            </template>
        </b-card>

        <b-alert variant="danger" show v-else-if="!userResource.attributes.credits_subscription_in_good_standing && userResource.attributes.credits_subscription_exists">
            <strong>Uh-oh!</strong> Your {{ $appConfig('APEX_CLUB_NAME', 'Apex Club') }} membership is not in good standing. Please
            <router-link :to="{ name: 'accountPayment' }">review your Payment Method</router-link> to fix this.
        </b-alert>

        <b-alert variant="info" show v-else>
            <strong>Save 20% on every race</strong> by joining <strong>{{ $appConfig('APEX_CLUB_NAME', 'Apex Club') }}</strong>. (And a whole lot more!)
            <router-link :to="{ name: 'subscription' }">More Info</router-link>
        </b-alert>

        <b-modal
            title="Cancel Subscription"
            ref="cancelSubscription"
            @ok="onUnenrollSubscription()"
            :ok-disabled="!userResource.attributes.credits_subscription_cancelable"
            cancel-title="Don't Cancel"
            cancel-variant="primary"
            ok-title="Cancel Subscription"
            ok-variant="danger"
            centered
            no-fade>
            <p>Are you sure you want to cancel your subscription? This action is irreversible.
                <span v-if="creditsBalance > 0"> <strong>You will lose your balance of {{ creditsBalance }} Credits!</strong> Consider using your credits before canceling.</span>
            </p>
            <b-alert variant="danger" :show="!userResource.attributes.credits_subscription_cancelable">
                <strong>Sorry, you can't cancel yet</strong> — you must be a member for at least two billing cycles. Please review our <terms-of-service-link text="Terms of Service" el="span" />.
            </b-alert>
        </b-modal>
    </div>
</template>
